export const MANATEE_CARE_PROVIDER = "Building Brave Kids";
export const CPT_CODE_INTAKE_60_MIN = "90791";

export const IS_PROD = process.env.NODE_ENV === "production";
export const IS_DEV = process.env.NODE_ENV === "development";
